import { axiosWithKey } from "~/axios";
import { getToken } from "~/redux/user/tokens";
import { userLanguageSelector } from "~/tools/localization";
import { find } from "lodash";
import jwtDecode from 'jwt-decode'

export const getClosedCaptions = (video) => {
    const enableCC = localStorage.getItem('closedCaption') !== "false";
    let finalCaptions = null;
    if(enableCC && video.contentDetails){
        finalCaptions = video.contentDetails.closedCaptions;
    }
    return finalCaptions;
}

export const enableAutoplay = () => {
    if(window.innerWidth < 768) {
        return false;
    } 
    return localStorage.getItem('autoplay') !== 'false';
}

export const getSiblingEpisodes = (season=null, episodeIdx) => {
    if(!season || !(episodeIdx >= 0)) return {prevEp:null, nextEp: null};
    const seasonLength = season.episodes.length;
    const prevEpIdx = episodeIdx - 1 >= 0 ? episodeIdx - 1 : seasonLength - 1;
    const nextEpIdx = ( episodeIdx + 1 ) % seasonLength;
    let prevEp = seasonLength > 1 ? season.episodes[prevEpIdx] : null;
    let nextEp = seasonLength > 1 ? season.episodes[nextEpIdx] : null;
    if(prevEpIdx === nextEpIdx){
        if(prevEpIdx === 0){
            nextEp = null;
        } else {
            prevEp = null;
        }
    }
    return { prevEp, nextEp, prevEpIdx, nextEpIdx };
}

export const getEpisodeIdx = (season=null, episodeId) => {
    let episodeIdx = null;
    if(!season) return null;
    season.episodes.forEach((episode, idx)=>{
        if(episode.gist.id === episodeId){
            episodeIdx = idx;
        }
    })
    return episodeIdx;
}

export const fetchSeriesData = async (seriesData = []) => {
    if(!seriesData || seriesData.length === 0) return [];
    const permalink = seriesData[0].gist.permalink;
    const { internalName } = window.settings;
    let seasons = [];
    const token = await getToken();
    var decodedToken = jwtDecode(token);
	var tokenCountryCode = decodedToken.countryCode
	let baseUrl = ""
	if(window.settings.apiBaseUrl === "https://prod-api.viewlift.com") {
		baseUrl = "https://prod-api-cached-2.viewlift.com"
	} else {
		baseUrl = window.settings.apiBaseUrlCached || window.settings.apiBaseUrl
	}
    const pageData = await axiosWithKey({
        method: "GET",
        url: `${baseUrl}/content/pages?site=${internalName}&path=${permalink}&countryCode=${tokenCountryCode}&languageCode=${userLanguageSelector()}&includeContent=true`,
        headers: { Authorization: token }
    });
    const seriesModule = pageData.data.modules.filter(e=>{
        return e.moduleType === 'ShowDetailModule' && e.contentData && e.contentData[0].gist.permalink === permalink;
    });
    if(seriesModule){
        seasons = seriesModule[0].contentData[0].seasons;
    }
    return seasons;
}

export const getSeasonIdx = (seasons, videoId) => {
    let seasonIdx = null;
    for(let i = 0; i < seasons.length; i++){
        for(let j = 0; j < seasons[i].episodes.length; j++){
            if(seasons[i].episodes[j].id === videoId){
                seasonIdx = i;
                break;
            }
        }
    }
    return seasonIdx;
}

export function removeLiveAndTrailerAndPromo(season) {
	const items = season.episodes;
	if (items) {
        season.episodes = items.filter(e => e.gist && !e.gist.isLiveStream && !e.gist.isTrailer && !(e.tags.length > 0 && find(e.tags, {'title': 'promo'})));
        return season;
	}
	return season;
}